import React, { useState, useEffect, Suspense, useMemo } from "react"; // Removed lazy, useNavigate, useLocation
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom"; // Moved Navigate here from useNavigate
import axios from "axios";
import BlankLayout from "./layout/blanklayout/BlankLayout";
import FullLayout from "./layout/full-layout/FullLayout";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

// SEO Pages
import BestCreativeAdvertisingAgencyInHyderabad from "./features/seo-pages/BestCreativeAdvertisingAgencyInHyderabad";
import BestDigitalMarketingAgencyInHyderabad from "./features/seo-pages/BestDigitalMarketingAgencyInHyderabad";
import BestPerformanceMarketingAgencyInHyderabad from "./features/seo-pages/BestPerformanceMarketingAgencyInHyderabad";
import BestSeoCompanyInHyderabad from "./features/seo-pages/BestSeoCompanyInHyderabad";
import BrandingAgencyInHyderabad from "./features/seo-pages/BrandingAgencyInHyderabad";
import CreativeAdvertisingAgencyInHyderabad from "./features/seo-pages/CreativeAdvertisingAgencyInHyderabad";
import DigitalMarketingAndBrandingServicesInHyderabad from "./features/seo-pages/DigitalMarketingAndBrandingServicesInHyderabad";
import PerformanceMarketingAgencyInHyderabad from "./features/seo-pages/PerformanceMarketingAgencyInHyderabad";
import SearchEngineMarketingAgencyInHyderabad from "./features/seo-pages/SearchEngineMarketingAgencyInHyderabad";
import SeoCompanyInHyderabad from "./features/seo-pages/SeoCompanyInHyderabad";
import SocialMediaMarketingCompanyInHyderabad from "./features/seo-pages/SocialMediaMarketingCompanyInHyderabad";
import WebsiteDevelopmentCompanyInHyderabad from "./features/seo-pages/WebsiteDevelopmentCompanyInHyderabad";
import WhatsappMarketingCompanyInHyderabad from "./features/seo-pages/WhatsappMarketingCompanyInHyderabad";
import SeoThankYou from "./features/seo-pages/SeoThankYou";
import Sitemap from "./features/seo-pages/Sitemap";

// New Blog Pages from G-Rank Blogs Content.docx
import HowToChooseTheRightDigitalMarketingAgencyForYourBusiness from "./features/blog-pages/HowToChooseTheRightDigitalMarketingAgencyForYourBusiness";
import HowAiIsTransformingDigitalMarketingIn2026 from "./features/blog-pages/HowAiIsTransformingDigitalMarketingIn2026";
import SeoVsPpcWhichIsBetterForBusinessGrowth from "./features/blog-pages/SeoVsPpcWhichIsBetterForBusinessGrowth";

function App() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const helmetContext = {};

  const ProtectedRoute = useMemo(() => {
    return ({ children }) => {
      const loggedUser = users.find((user) => user.role === "admin");
      console.log("loggedUser-div:", loggedUser);
      return loggedUser ? children : <Navigate to="/login" />;
    };
  }, [users]);

  useEffect(() => {
    axios
      .get("https://server.grank.co.in/api/v1/users", { timeout: 3000 })
      .then((res) => {
        setUsers(res?.data || []);
      })
      .catch((err) => {
        console.log("Users API notice:", err?.message || err);
      });
  }, []);

  return (
    <>
      <HelmetProvider context={helmetContext}>
        <Suspense fallback={<div>Loading components...</div>}>
          <Routes>
            {/* SEO Pages from cpanel_files */}
            <Route path="/best-creative-advertising-agency-in-hyderabad" element={<BestCreativeAdvertisingAgencyInHyderabad />} />
            <Route path="/best-digital-marketing-agency-in-hyderabad" element={<BestDigitalMarketingAgencyInHyderabad />} />
            <Route path="/best-performance-marketing-agency-in-hyderabad" element={<BestPerformanceMarketingAgencyInHyderabad />} />
            <Route path="/best-seo-company-in-hyderabad" element={<BestSeoCompanyInHyderabad />} />
            <Route path="/branding-agency-in-hyderabad" element={<BrandingAgencyInHyderabad />} />
            <Route path="/creative-advertising-agency-in-hyderabad" element={<CreativeAdvertisingAgencyInHyderabad />} />
            <Route path="/digital-marketing-agency-in-hyderabad" element={<Navigate to="/" replace />} />
            <Route path="/digital-marketing-and-branding-services-in-hyderabad" element={<DigitalMarketingAndBrandingServicesInHyderabad />} />
            <Route path="/performance-marketing-agency-in-hyderabad" element={<PerformanceMarketingAgencyInHyderabad />} />
            <Route path="/search-engine-marketing-agency-in-hyderabad" element={<SearchEngineMarketingAgencyInHyderabad />} />
            <Route path="/seo-company-in-hyderabad" element={<SeoCompanyInHyderabad />} />
            <Route path="/social-media-marketing-company-in-hyderabad" element={<SocialMediaMarketingCompanyInHyderabad />} />
            <Route path="/website-development-company-in-hyderabad" element={<WebsiteDevelopmentCompanyInHyderabad />} />
            <Route path="/whatsapp-marketing-company-in-hyderabad" element={<WhatsappMarketingCompanyInHyderabad />} />
            <Route path="/seo-thankyou" element={<SeoThankYou />} />
            <Route path="/sitemap.php" element={<Sitemap />} />
            <Route path="/sitemap" element={<Sitemap />} />

            {/* Blog Pages from G-Rank Blogs Content.docx */}
            <Route path="/how-to-choose-the-right-digital-marketing-agency-for-your-business" element={<HowToChooseTheRightDigitalMarketingAgencyForYourBusiness />} />
            <Route path="/how-ai-is-transforming-digital-marketing-in-2026" element={<HowAiIsTransformingDigitalMarketingIn2026 />} />
            <Route path="/seo-vs-ppc-which-is-better-for-business-growth" element={<SeoVsPpcWhichIsBetterForBusinessGrowth />} />

            <Route path="/*" element={<BlankLayout />} />
            <Route
              path="/secured/*"
              element={
                <ProtectedRoute>
                  <FullLayout />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Suspense>
      </HelmetProvider>
      <a
        href="https://wa.me/919963391666?text=Hello"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <WhatsAppIcon className="whatsapp-icon" />
      </a>
    </>
  );
}

export default App;
